import { render, staticRenderFns } from "./LanguageConfig.vue?vue&type=template&id=201d26ed&scoped=true"
import script from "./LanguageConfig.vue?vue&type=script&lang=ts"
export * from "./LanguageConfig.vue?vue&type=script&lang=ts"
import style0 from "./LanguageConfig.vue?vue&type=style&index=0&id=201d26ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201d26ed",
  null
  
)

export default component.exports